/* MXDVS recent searches (06.10.2026). Phones and desktop.
   Keeps the visitor's last searches in their own browser (localStorage, nothing leaves the device)
   and shows them under the search line in the search window while the line is empty.
   A search is kept when a search form is sent and when the /search page opens with a term,
   wherever it was typed. Click a term to search it again; Clear empties the list.
   Settings come from the MXDVS header section (theme editor > Header > MXDVS header > Search),
   printed as window.mxdvsRecentSearch by sections/mxdvs-rail.liquid. */
(function () {
  if (window.__mxRecent) return;
  window.__mxRecent = true;

  var KEY = 'mxdvs-recent-searches';
  var cfg = window.mxdvsRecentSearch || {};
  var MAX = typeof cfg.max === 'number' ? cfg.max : 5;

  function load() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (s) { return typeof s === 'string' && s.trim(); }) : [];
    } catch (e) { return []; }
  }
  function store(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 20))); } catch (e) {}
  }
  function add(term) {
    term = String(term || '').trim().replace(/\s+/g, ' ').slice(0, 60);
    if (term.length < 2) return;
    store([term].concat(load().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); })));
  }

  /* The /search page with a term counts as a search, wherever it was typed */
  try {
    var u = new URL(window.location.href);
    if (/\/search\/?$/.test(u.pathname) && u.searchParams.get('q')) add(u.searchParams.get('q'));
  } catch (e) {}

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/search"]')) return;
    var q = f.querySelector('input[name="q"]');
    if (q && q.value) add(q.value);
  }, true);

  function render(details) {
    var field = details.querySelector('.search-modal .field');
    var input = field && field.querySelector('.search__input');
    if (!input) return;
    var box = details.querySelector('[data-mx-recent]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mx-recent';
      box.setAttribute('data-mx-recent', '');
      box.innerHTML = '<div class="mx-recent__head"><p class="mx-recent__title"></p>' +
        '<button type="button" class="mx-recent__clear"></button></div><ul class="mx-recent__list" role="list"></ul>';
      field.parentNode.insertBefore(box, field.nextSibling);
      box.addEventListener('click', function (e) {
        if (e.target.closest('.mx-recent__clear')) {
          e.preventDefault();
          store([]);
          render(details);
          input.focus();
          return;
        }
        var b = e.target.closest('.mx-recent__term');
        if (!b) return;
        e.preventDefault();
        input.value = b.textContent;
        var form = input.form;
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else { add(input.value); form.submit(); }
      });
      input.addEventListener('input', function () { render(details); });
    }
    var list = MAX > 0 ? load().slice(0, MAX) : [];
    box.querySelector('.mx-recent__title').textContent = cfg.heading || 'Recent searches';
    box.querySelector('.mx-recent__clear').textContent = cfg.clear || 'Clear';
    var ul = box.querySelector('.mx-recent__list');
    ul.textContent = '';
    list.forEach(function (t, i) {
      var li = document.createElement('li');
      li.style.setProperty('--i', i);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mx-recent__term';
      b.textContent = t;
      li.appendChild(b);
      ul.appendChild(li);
    });
    box.hidden = !list.length || !!input.value;
  }

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('.header__search > details') && d.open) render(d);
  }, true);
})();
